import { Box, ListItem, SectionHeader, useTheme } from "arkh";
import { FormattedMessage, useIntl } from "react-intl";
import React, { PropsWithChildren } from "react";

import { Goal } from "../State/Routine/types";
import { Switch } from "react-native-gesture-handler";
import { SegmentedControl } from "../../../components/SegmentedControl";
import { NumberGoalValueInput } from "../../../components/mobile/NumberGoalValueInput";

export const NumberGoal = (
  props: PropsWithChildren<{
    goalDirection?: Goal;
    setGoalDirection(goal?: Goal): void;
    goalValue?: number;
    setGoalValue?(_: number): void;
  }>
) => {
  const intl = useIntl();
  const theme = useTheme();
  return (
    <Box
      color="surface"
      cornerRadiusBottomLeft="large"
      cornerRadiusBottomRight="large"
    >
      <ListItem
        right={
          <Switch
            value={props.goalDirection !== undefined}
            onValueChange={(value) => {
              props.setGoalDirection(value ? "min" : undefined);
            }}
            trackColor={{ false: theme.washedText, true: theme.primary }}
            thumbColor={theme.background}
          />
        }
        isLast
      >
        <SectionHeader.Title>
          <FormattedMessage
            defaultMessage="Set goal"
            description="Number Goal title"
          />
        </SectionHeader.Title>
        <Box spaceVertical="xsmall">
          <SectionHeader.Description>
            <FormattedMessage
              defaultMessage="Set a goal for your task. The goal will be shown in graphs and when performing the task."
              description="Number Goal description"
            />
          </SectionHeader.Description>
        </Box>
      </ListItem>
      {props.goalDirection &&
      props.goalValue !== undefined &&
      props.setGoalValue !== undefined ? (
        <Box
          style={{ alignSelf: "stretch", alignItems: "center" }}
          space="medium"
        >
          <NumberGoalValueInput
            goal={props.goalDirection}
            value={props.goalValue}
            setValue={props.setGoalValue}
          />
        </Box>
      ) : null}
      {props.goalDirection ? (
        <Box spaceVertical="medium" spaceHorizontal="medium">
          <SegmentedControl
            values={[
              intl.formatMessage({
                defaultMessage: "More than",
                description: "Number Goal min goal label",
              }),
              intl.formatMessage({
                defaultMessage: "Less than",
                description: "Number Goal max goal label",
              }),
            ]}
            onChange={(event) => {
              const index = event.nativeEvent.selectedSegmentIndex;
              props.setGoalDirection(index === 0 ? "min" : "max");
            }}
            selectedIndex={props.goalDirection === "min" ? 0 : 1}
          />
        </Box>
      ) : null}
      {props.goalDirection ? props.children : null}
    </Box>
  );
};
